module.exports = __webpack_public_path__ + "img/pic_lhfwt.11c7ac44.png";